import { Form } from '@models/membership/Form'
import { fetchFormAnswersForEntity } from '@services/membership/FormAnswerService'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Empty, Flex, Spin } from 'antd'
import { FC, useEffect, useState } from 'react'
import { Subscription as SubscriptionModel } from '../../../models/membership/Subscription'
import { useAppSelector } from '../../../store/hooks'
import { selectSubscriptionById } from '../../../store/membership/SubscriptionReducer'
import { FormRender } from '../form/FormRender'

type Props = SBModelComponent<SubscriptionModel> & {}

/**
 * Despite we're used to pass all resources via the store, here we use local state
 * as we did for the MembershipProfile.Description
 * Even though this component is NOT likely to be used multiple times on the same page with different ids
 * we keep the same pattern for consistency.
 */
const SubscriptionFormAnswers: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectSubscriptionById(id!))

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [form, setForm] = useState<Form>()

  useEffect(() => {
    if (!item) return

    setIsLoading(true)
    fetchFormAnswersForEntity('subscription', item.id)
      .then((data) => {
        setForm(data.data)
      })
      .finally(() => setIsLoading(false))
  }, [item])

  if (isLoading) {
    return <Spin />
  }

  if (!item || form?.steps.length == 0) {
    return (
      <Flex
        vertical
        gap={24}
        align="center"
        justify="center"
        style={{ minHeight: 200 }}
      >
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={'Form answers not found'}
        />
      </Flex>
    )
  }

  return <FormRender form={form} />
}

type SubscriptionFormAnswersType = {
  FormAnswers: typeof SubscriptionFormAnswers
}

export { SubscriptionFormAnswers, type SubscriptionFormAnswersType }
